const {GEAR_WARHAMMER} = require('./../../gearIdList')

const hammersDescription = `Используемые как инструменты для строительства, сноса и ковки, молотки стали излюбленным оружием среди некоторых из самых крепких рас, включая орков и дварфов, которые очень сильны от природы.

Размеры молотков варьируются от кузнечных молотков до огромных боевых молотов. Многие из них — просто тяжёлые тупые штуки для битья врагов и пробивания доспехов, но другие, например — [боевые молоты](GEAR:${GEAR_WARHAMMER}) сконструированы как впечатляющее сокрушительное оружие с длинной рукоятью и маленькой тяжёлой головкой, которое можно использовать быстро и ловко.`

module.exports = hammersDescription
